var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(_vm.$route.meta.header)?_c('TopNavBar'):_vm._e(),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),(_vm.$route.meta.footer)?_c('PageFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }